angular.module('core')
  .filter('reverse', () => items => !Array.isArray(items) ? items : items.slice().reverse());
